import { render, staticRenderFns } from "./ceping-bidui.vue?vue&type=template&id=15a6bc42&scoped=true"
import script from "./ceping-bidui.vue?vue&type=script&lang=ts"
export * from "./ceping-bidui.vue?vue&type=script&lang=ts"
import style0 from "./ceping-bidui.vue?vue&type=style&index=0&id=15a6bc42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6bc42",
  null
  
)

export default component.exports